<template>
  <div class="content-wrapper">
    <ContentHeader title="Топливные талоны" />
    <div class="content-body">
      <div class="row">
        <div class="col-xs-12">
          <card
            headerTitle="Остаток на балансе"
            :busy="isTicketsLoading"
            hideFooter
            @reload="reloadTickets"
          >
            <template slot="block">
              <div style="margin-bottom: 40px;">
                <div class="float-xl-right float-sm-none mt10">
                  <button
                    class="btn btn-success btn-block btn-min-width bg-green bg-darken-3 btn-hover"
                    @click="showModal = true"
                  >
                    <i class="icon-cart4" style="padding-right: 15px;"></i> Заказать топливные талоны
                  </button>
                </div>
                <div>
                  <p style="padding-left: 10px;">Остатки в литрах на текущий момент.</p>
                </div>
              </div>
              <b-table
                show-empty
                hover
                bordered
                responsive
                thead-class="bg-grey bg-lighten-2"
                :emptyText="isTicketsFailed?'Ошибка подключения. Попробуйте позже':'Записи отсутствуют'"
                emptyFilteredText="Записи не найдены"
                :busy="isTicketsLoading"
                :items="getTicketsBalances"
                :fields="ticketsFields"
              >
                <template v-slot:cell(active_quantity)="data">
                  <div>
                    <span
                      class="tag tag-default bg-green bg-darken-1 text-xs-center"
                    >{{ data.value }}</span>
                    <router-link to="/tickets/details?ticket_type=active">
                      <kbd>
                        <i class="icon-file-text-o"></i>
                      </kbd>
                    </router-link>
                  </div>
                </template>
                <template v-slot:cell(used_quantity)="data">
                  <div>
                    <span
                      class="tag tag-default bg-warning bg-darken-3 text-xs-center"
                    >{{ data.value }}</span>
                    <router-link to="/tickets/details?ticket_type=used">
                      <kbd>
                        <i class="icon-file-text-o"></i>
                      </kbd>
                    </router-link>
                  </div>
                </template>
                <template v-slot:cell(block_quantity)="data">
                  <div>
                    <span class="tag tag-default bg-red bg-darken-2 text-xs-center">{{ data.value }}</span>
                    <router-link to="/tickets/details?ticket_type=block">
                      <kbd>
                        <i class="icon-file-text-o"></i>
                      </kbd>
                    </router-link>
                  </div>
                </template>
              </b-table>
            </template>
          </card>
        </div>
      </div>
      <BillTable
        title="ДОЛИВНЫЕ ЧЕКИ"
        :fields="checksFields"
        :items="getChecks"
        :busy="isChecksLoading"
        :failed="isChecksFailed"
        @reload="reloadChecks"
      >
        <template slot="top">
          <div></div>
        </template>
      </BillTable>
      <!-- Заказ талонов -->
      <modal
        :id="modalId"
        v-if="showModal"
        @close="closeModal"
        @cancel="closeModal"
        @ok="requestTickets"
      >
        <template slot="header-title">Заказать топливные талоны</template>
        <template slot="body">
          <p>После отправки запроса, система сформирует заявку. Когда заявка будет обработана, новый счет появится в разделе «Счета на оплату», а так же в области уведомлений появится сообщение о новом счете.</p>
          <label>Объём, литры:</label>
          <div class="form-group">
            <input
              type="number"
              placeholder="Укажите объём"
              class="form-control"
              min="0"
              v-model="ticketRequestQuantity"
            />
          </div>
        </template>
        <template slot="ok-title">Создать заявку</template>
      </modal>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import BillTable from "@/components/BillTable.vue";
import modal from "@/components/modal.vue";
import card from "@/components/card.vue";
import { mapGetters } from "vuex";
import {
  TICKETS_REQUEST,
  TICKETS_CHECKS_REQUEST,
} from "@/store/actions/tickets";
import { REQUESTS_ADD_REQUEST } from "@/store/actions/requests";

export default {
  name: "Tickets",
  components: {
    ContentHeader,
    BillTable,
    modal,
    card,
  },
  data() {
    return {
      modalId: "modal",
      showModal: false,
      ticketRequestQuantity: null,
      ticketsFields: [
        {
          key: "product_name",
          label: "Тип топлива",
        },
        {
          key: "active_quantity",
          label: "Активные, литры",
        },
        {
          key: "used_quantity",
          label: "Погашенные, литры",
        },
        {
          key: "block_quantity",
          label: "Заблокированные, литры",
        },
        {
          key: "total",
          label: "За всё время, литры",
          formatter(value, index, item) {
            return (
              item.active_quantity + item.used_quantity + item.block_quantity
            );
          },
        },
      ],
      checksFields: [
        {
          key: "ticket_id",
          label: "№ Доливного чека",
        },
        {
          key: "product_name",
          label: "Вид топлива",
        },
        {
          key: "azs",
          label: "АГЗС выдавшая чек",
          formatter(value, index, item) {
            return `АГЗС №${item.azs} ${item.region}`;
          },
        },
        {
          key: "auth_date",
          label: "Дата и время активации",
          formatter(value) {
            return new Date(value).toLocaleString();
          },
        },
        {
          key: "edate",
          label: "Дата и время окончания действия",
          formatter(value, index, item) {
            let d = new Date(item.auth_date);
            d.setDate(d.getDate() + 1);
            return d.toLocaleString();
          },
        },
        {
          key: "rest",
          label: "Остаток, литры",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getTickets",
      "getTicketsBalances",
      "isTicketsLoading",
      "isTicketsFailed",
      "ticketsOnceLoaded",

      "getChecks",
      "isChecksLoading",
      "isChecksFailed",
      "checksOnceLoaded",
    ]),
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.ticketRequestNominal = null;
      this.ticketRequestQuantity = null;
    },
    requestTickets() {
      let body = JSON.stringify({
        products: [
          {
            type: "ticket_fuel",
            name: `Топливные талоны СГ`,
            quantity: this.ticketRequestQuantity,
            units: "л",
          },
        ],
      });
      this.$store.dispatch(REQUESTS_ADD_REQUEST, { body }).then(() => {
        this.closeModal();
      });
    },
    reloadTickets() {
      this.$store.dispatch(TICKETS_REQUEST);
    },
    reloadChecks() {
      this.$store.dispatch(TICKETS_CHECKS_REQUEST);
    },
  },
  beforeMount() {
    // use this component's unique client-side Vue ID
    this.modalId = `modal-${this._uid}`;
  },
  created() {
    if (!this.ticketsOnceLoaded) this.$store.dispatch(TICKETS_REQUEST);
    if (!this.checksOnceLoaded) this.$store.dispatch(TICKETS_CHECKS_REQUEST);
  },
};
</script>